import React from "react";
import { Tag } from "antd";

import { quoteStatus } from "./const";

/*
export const getJobStatusBySelect = () => {
    return jobStatus.map((e) => ({ value: e.key, label: e.name }));
};

export const isFinalStatus = (status) => {
    if (status == jobStatusCompleted || status == jobStatusDelivered) {
        return true;
    }
    return false;
};

export const getStatusColor = (status) => {
    return jobStatus.find((e) => e.key == status).color;
};

//{ key: "At Proofread",name:"At Proofread", color: "#87d068", ico:<DoubleRightOutlined /> }, //se elimina
//{ key: "Ready to Deliver",name:"Ready to Deliver", color: "#87d068", ico:<DoubleRightOutlined /> },  // se elimina porque no estaba en el listado, se cambia a Ready for next step

*/
const StatusLabel = (props) => {
    const singelton = quoteStatus.filter((item) => item.key === props.status);

    const color = singelton.length === 1 ? singelton[0].color : "#f50";

    return <Tag color={color}>{props.status}</Tag>;
};

export default StatusLabel;
